import React, { useEffect } from "react";
import Block from "ComponentsUI/Block";
import { TARIFFS_BY_REGION } from "Services/queries";
import { DECLINATION_QUERY } from "Configs/queries";
import { TariffsTable, TariffsHeaderRow } from "ComponentsUI/TarifficationB";
import { useQuery } from "@apollo/client";
import { useParams } from "react-router-dom";
import useDefaultParams from "Services/useDefaultParams";
import { sendMetriks } from "Services/sendMetriks";
import {
	TariffsLayout as MicroMarkupTariffsLayout,
	OfferLayout as MicroMarkupOfferLayout,
} from "Layouts/MicroMarkup";
import {} from "Layouts/MicroMarkup";
import { HeaderTextSeo } from "ComponentsUI/SeoBlock";

import RecentlyConnectedRowContainer from "Containers/RecentlyConnectedRowContainer";
import { Redirect404 } from "ComponentsUI/Redirects";

const RecentlyConnectedTariffsContainer = (props) => {
	const {
		ApplicationModel: {
			text,
			siteConfig,
			windowSizeModel: { windowSizes },
		},
		skipLayout,
		seoBlock,
	} = props;
	const routerParams = useParams();
	const defaultParams = useDefaultParams(routerParams);
	let tariffsForView = [];

	let variables = {
		region_url: defaultParams.regionUrl,
		limit: 5,
		shuffle: 1,
		actualProviderRating: true,
		vip_provider: 1,
		excludeCard: 3,
		providerJoin: true,
	};

	// Запрос в БД на тарифы в регионе
	const tariffsByRegion = useQuery(TARIFFS_BY_REGION, {
		variables: variables,
	});

	useEffect(() => {
		let tariffs = tariffsByRegion?.data?.tariffsByRegion?.data;

		if (!!tariffs?.length) {
			sendMetriks("OPEN_RECENTLY_CONNECTED_PROVIDERS");
		}
	}, [tariffsByRegion.loading]);

	// Запрос в БД на падежи имен регионов
	const declinationName = useQuery(DECLINATION_QUERY, {
		variables: {
			filter: `url=${defaultParams.regionUrl}`,
		},
	});

	// Проверка загрузки данных и их отсутствие
	if (tariffsByRegion.loading) {
		return null;
	}

	if (declinationName.loading) {
		return null;
	}

	let tariffs = !tariffsByRegion.loading ? tariffsByRegion.data?.tariffsByRegion?.data : [];
	if (tariffs === undefined) {
		tariffs = [];
	}

	if (!tariffs.length) {
		return null;
	}

	if (props.isReviewsProviders) {
		if (windowSizes.xs && tariffs.length > 3) {
			tariffsForView = tariffs.slice(0, 3);
		} else {
			tariffsForView = tariffs;
		}
	} else {
		tariffsForView = tariffs;
	}

	if (props.match.params.page > 1 && props.isRates) {
		return (
			<Redirect404 message404={"Пагинация в тарифах провайдера, у которого вообще нет тарифов"} />
		);
	}

	const regionName = declinationName?.data?.region?.declinations?.prepositional;
	const header = `Недавно подключенные тарифы в ${regionName}`;

	let tableHeader = <TariffsHeaderRow texts={text} showName={true} />;

	// Проверка на наличие тарифов у оператора
	if (tariffsForView.length) {
		return (
			<Block
				stub={tariffsByRegion.loading}
				withoutBottomPadding={false}
				headerWithoutMargin={true}
				styleReviewsProvider={props.styleReviewsProvider}
			>
				<HeaderTextSeo header={seoBlock?.seoHeader || header} text={seoBlock?.seoText} />
				<div className="container" data-test="countRates" data-count={tariffsForView.length}>
					<MicroMarkupTariffsLayout tariffs={tariffsForView} skipLayout={skipLayout}>
						<TariffsTable datatest={props.datatest} tableHeader={tableHeader}>
							{tariffsForView.map((item) => {
								return (
									<MicroMarkupOfferLayout tariff={item} key={item.id} siteConfig={siteConfig}>
										<RecentlyConnectedRowContainer
											data={item}
											isRecently={true}
											isRates={props.isRates}
											isCard={props.isCard}
											isOrderToHome={props.isOrderToHome}
											isReviewsProviders={props.isReviewsProviders}
											pageName={props.pageName}
											styleReviewsProvider={props.styleReviewsProvider}
										/>
									</MicroMarkupOfferLayout>
								);
							})}
						</TariffsTable>
					</MicroMarkupTariffsLayout>
				</div>
			</Block>
		);
	} else {
		return null;
	}
};

export default RecentlyConnectedTariffsContainer;
